import http from "./http.service";
import Promisable from "./promisable.service";
import { getAppDispatch } from "utils/dispatch.util";
import { dynamicActions } from "redux/slices/dynamics/dynamicSlice";
import { modalActions } from "redux/slices/modal";
import { loaderActions } from "redux/slices/loader";

const url = "/dynamics";

const DynamicService = {

  updateDynamic: async (id: any, data: any) => {

    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.patch(`${url}/${id}`, data)
    );

    if (success) {
      dispatch?.(modalActions.closeModal());
      dispatch?.(modalActions.setLoading(false));
      DynamicService.getDynamics()

    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  getDynamics: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(dynamicActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}`)
    );

    if (success) {
      const { dynamics } = success.data.data;

      dispatch?.(dynamicActions.setdynamics(dynamics))
    }

    dispatch?.(dynamicActions.setLoading(false));
    return [success, error];
  },
  addBannerPic: async (data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(loaderActions.setLoading(true));

    http.setJWT();
    http.setMultiPart();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/banner-pic`, data)
    );

    if (success) {
      const { dynamicBanner } = success.data.data;
      dispatch?.(dynamicActions.setdynamicBanner(dynamicBanner));

    }

    dispatch?.(loaderActions.setLoading(false));
    return [success, error];
  },
  getBannerPic: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(loaderActions.setLoading(true));

    http.setJWT();
    http.setMultiPart();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/banner-pic`)
    );

    if (success) {
      const { dynamicBanner } = success.data.data;
      dispatch?.(dynamicActions.setdynamicBanner(dynamicBanner));

    }

    dispatch?.(loaderActions.setLoading(false));
    return [success, error];
  },
  addBannerJeenyPic: async (data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(loaderActions.setLoading(true));

    http.setJWT();
    http.setMultiPart();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/jeeny-banner-pic`, data)
    );

    if (success) {
      const { dynamicBanner } = success.data.data;
      dispatch?.(dynamicActions.setJeenyBanner(dynamicBanner));

    }

    dispatch?.(loaderActions.setLoading(false));
    return [success, error];
  },
  getBannerJeenyPic: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(loaderActions.setLoading(true));

    http.setJWT();
    http.setMultiPart();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/jeeny-banner-pic`)
    );

    if (success) {
      const { dynamicBanner } = success.data.data;
      dispatch?.(dynamicActions.setJeenyBanner(dynamicBanner));

    }

    dispatch?.(loaderActions.setLoading(false));
    return [success, error];
  },
  getCrossCountryPrices: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(loaderActions.setLoading(true));

    http.setJWT();
    http.setMultiPart();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/country-prices`)
    );

    if (success) {
      const { countryPrices } = success.data.data;
      dispatch?.(dynamicActions.setCountryPrices(countryPrices));

    }

    dispatch?.(loaderActions.setLoading(false));
    return [success, error];
  },
  updateCrossCountryPrice: async (id: any, data: any) => {

    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/country-price/${id}`, data)
    );

    if (success) {
      dispatch?.(modalActions.closeModal());
      dispatch?.(modalActions.setLoading(false));
      DynamicService.getCrossCountryPrices();

    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  getDynamicCarMovement: async (type: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(dynamicActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/car-movement?type=${type}`)
    );

    if (success) {
      const { dynamicsMovement } = success.data.data;
      dispatch?.(dynamicActions.setDynamicCarMovement({ data: dynamicsMovement, type }));

    }
    dispatch?.(dynamicActions.setLoading(false));
    return [success, error];
  },
  addDynamicCarMovement: async (data: any) => {
    const dispatch = getAppDispatch();
    const { type } = data;
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/car-movement`, data)
    );

    if (success) {
      DynamicService.getDynamicCarMovement(type)
      dispatch?.(modalActions.closeModal());

    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  updateDynamicCarMovement: async (id: any, data: any) => {
    const dispatch = getAppDispatch();
    const { type } = data;
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/car-movement/${id}`, data)
    );

    if (success) {
      DynamicService.getDynamicCarMovement(type)
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },





  getDynamicSection: async (type: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(dynamicActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/selections?type=${type}`)
    );

    if (success) {
      const { selections } = success.data.data;
      dispatch?.(dynamicActions.setDynamicSelection({ data: selections, type }));

    }
    dispatch?.(dynamicActions.setLoading(false));
    return [success, error];
  },
  addDynamicSelections: async (data: any) => {
    const dispatch = getAppDispatch();
    const { type } = data;
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/selections`, data)
    );

    if (success) {
      DynamicService.getDynamicSection(type)
      dispatch?.(modalActions.closeModal());

    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  updateDynamicSelections: async (id: any, data: any) => {
    const dispatch = getAppDispatch();
    const { type } = data;
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.patch(`${url}/selections/${id}`, data)
    );

    if (success) {
      DynamicService.getDynamicSection(type)
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  getTanfeethi: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(dynamicActions.setLoading(true));

    http.setJWT();
    http.setMultiPart();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/tanfeethi`)
    );

    if (success) {
      const { tanfeethi } = success.data.data;
      dispatch?.(dynamicActions.setTanfeethi(tanfeethi));
    }
    dispatch?.(dynamicActions.setLoading(false));

    return [success, error];
  },
  updateTanfeethi: async (id: any, data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/tanfeethi/${id}`, data)
    );

    if (success) {
      dispatch?.(modalActions.closeModal());
      dispatch?.(modalActions.setLoading(false));
      DynamicService.getTanfeethi();
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },

  getAlMasar: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(dynamicActions.setLoading(true));

    http.setJWT();
    http.setMultiPart();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/al-masar`)
    );

    if (success) {
      const { al_masar } = success.data.data;
      dispatch?.(dynamicActions.setAlMasar(al_masar));
    }
    dispatch?.(dynamicActions.setLoading(false));

    return [success, error];
  },
  updateAlMasar: async (id: any, data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));

    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/al-masar/${id}`, data)
    );

    if (success) {
      dispatch?.(modalActions.closeModal());
      dispatch?.(modalActions.setLoading(false));
      DynamicService.getAlMasar();
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },


  uploadKioskHomeVideo: async (formData: FormData) => {
    const dispatch = getAppDispatch();
    dispatch?.(dynamicActions.setLoading(true));
    http.setJWT();
    http.setMultiPart?.();
    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/kiosk-media`, formData)
    );
    if(success){
      window.location.reload()
    }
    dispatch?.(dynamicActions.setLoading(false));

    return [success, error];
  },
  getKioskMedia: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(loaderActions.setLoading(true));
    http.setJWT();
    http.setMultiPart?.();
    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/kiosk-media`)
    );
    if (success) {
      const { kioskMedia } = success.data.data;
      dispatch?.(dynamicActions.setVideo(kioskMedia));
    }
    dispatch?.(loaderActions.setLoading(false));
    return [success, error];
  },

  deleteKioskHomeVideo: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));
    http.setJWT();
    const [success, error]: any = await Promisable.asPromise(
      http.delete(`${url}/kiosk-media`)
    );
    if (success) {
      DynamicService.getKioskMedia();
      dispatch?.(modalActions.closeModal());
    }
    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  // Contentful Cache
  getContentfulCache: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(dynamicActions.setLoading(true));
    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/contentful-cache`)
    );

    if (success) {
      const { contentfulCache } = success.data.data || {};
      dispatch?.(dynamicActions.setContentfulCache(contentfulCache || []));
    }

    dispatch?.(dynamicActions.setLoading(false));
    return [success, error];
  },
  deleteContentfulCache: async (cacheId: string) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));
    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.delete(`${url}/contentful-cache/${cacheId}`)
    );

    if (success) {
      await DynamicService.getContentfulCache();
      dispatch?.(modalActions.closeModal());
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
  getAggregatorMarkups: async () => {
    const dispatch = getAppDispatch();
    dispatch?.(dynamicActions.setLoading(true));
    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.get(`${url}/aggregator-markups`)
    );

    if (success) {
      const { aggregatorMarkups } = success.data.data;
      dispatch?.(dynamicActions.setAggregatorMarkups(aggregatorMarkups || []));
    }

    dispatch?.(dynamicActions.setLoading(false));
    return [success, error];
  },
  updateAggregatorMarkup: async (id: string, data: any) => {
    const dispatch = getAppDispatch();
    dispatch?.(modalActions.setLoading(true));
    http.setJWT();

    const [success, error]: any = await Promisable.asPromise(
      http.post(`${url}/aggregator-markup/${id}`, data)
    );

    if (success) {
      dispatch?.(modalActions.closeModal());
      dispatch?.(modalActions.setLoading(false));
      DynamicService.getAggregatorMarkups();
    }

    dispatch?.(modalActions.setLoading(false));
    return [success, error];
  },
};

export default DynamicService;
